module.exports = __webpack_public_path__ + "static/media/thomas-kurian.8986b699.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/thomas-kurian.jpeg
// module id = 332
// module chunks = 0